import { FunctionComponent } from 'react';
import l from '../../../../lang';
import ButtonCustom from '../../../common/__deprecated__/button-custom';
import { openNewTabAndFocus } from '../../../../utils';
import { Urls } from '../../../../config/urls';
import { segmentIntegrationsShopifyInstall } from '../../../../utils/analytics';

export const AddShopifyInstallButton: FunctionComponent<{ size: string }> = ({ size }) => (
  <div className="add-to-shopify__btn">
    <ButtonCustom
      text={l('paymentIntegration.shopify.add')}
      variant="contained"
      size={size}
      onClick={() => {
        segmentIntegrationsShopifyInstall();
        openNewTabAndFocus(Urls.shopifyAddDP)
      }}
      component={undefined}
      innerComponent={undefined}
      fullWidth={undefined}
    />
  </div>
);
